import React from 'react';
import './QuestionTracker.css';

function QuestionTracker({ questions, unlockedQuestions, onQuestionClick }) {
  // Create a mapping from internal question IDs to display numbers (1-4)
  // This maps Q1/Q3/Q5/Q6 internally to Q1/Q2/Q3/Q4 for display
  const displayNumberMap = {
    '1': 1, // Q1 stays as Q1
    '3': 2, // Q3 displays as Q2
    '5': 3, // Q5 displays as Q3
    '6': 4  // Q6 displays as Q4
  };
  
  // Check if all questions are completed
  const allCompleted = unlockedQuestions.length === Object.keys(questions).length && unlockedQuestions.length > 0;
  
  return (
    <div className={`questions-tracker ${allCompleted ? 'all-completed' : ''}`}>
      <h3>Topics to explore:</h3>
      
      {/* Show completion message at the top when all questions are completed */}
      {allCompleted && (
        <div className="completion-message">
          🏆 All topics explored!
        </div>
      )}
      
      <div className="questions-list">
        {Object.entries(questions).map(([id, questionData]) => {
          const isUnlocked = unlockedQuestions.includes(parseInt(id));
          return (
            <div 
              key={id} 
              className={`progress-item ${isUnlocked ? 'unlocked' : 'locked'} clickable`}
              onClick={() => onQuestionClick && onQuestionClick(id, questionData.question)}
              title="Click to ask about this topic"
            >
              {isUnlocked ? 
                <span className="checkmark">✓</span> : 
                <span className="lock">🔒</span>
              }
              <div>
                <span>Q{displayNumberMap[id]}</span>
                <div>{id === '1' ? 'Role of professors' : 
                  id === '3' ? 'Student use' : 
                  id === '5' ? 'AI and efficiency' : 
                  'Stance to adopt'}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default QuestionTracker;
